module.exports = __webpack_public_path__ + "img/aboutDMIP.4feb0486.jpg";